<template>
  <select v-model="language" v-on:change="changeLang">
    <option v-for="(locale,index) in languages" :value="index" :key="locale">{{Language =='zh' && locale == 'Chinese'?'中文':locale}}</option>
  </select>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../config'

export default {
	data() {
		return {
      languages: config.languages,
      language: this.$store.getters['language/code'],
    }
	},
	computed: {
		...mapGetters({
			Language: 'language/code',
		})
	},
	methods: {
		changeLang(event) {
      this.$bus.$emit('ChangeLang', event)
    },

	}
}
</script>



// WEBPACK FOOTER //
// Language.vue?29acda0c